import { EmailingService, GetEmailByTemplateModel } from 'api/generated';
import { QueryError, formatErrorMessage } from 'features/shared/model';
import { UseMutationOptions, useMutation } from 'react-query';
import { toast } from 'react-toastify';

export const useGetEmailByTemplateMutation = (
  options?: Omit<
    UseMutationOptions<
      Awaited<ReturnType<typeof EmailingService.postGetEmailByTemplate>>,
      QueryError,
      GetEmailByTemplateModel,
      unknown
    >,
    'mutationFn'
  >
) =>
  useMutation(
    (model: GetEmailByTemplateModel) => {
      return EmailingService.postGetEmailByTemplate(model);
    },
    {
      ...options,
      onError: (error: QueryError) => {
        const message = formatErrorMessage(error);
        toast.error(message);
        console.error(message);
      }
    }
  );
